import { render } from "./TransferResult.vue?vue&type=template&id=bfe95eba&scoped=true"
import script from "./TransferResult.vue?vue&type=script&lang=js"
export * from "./TransferResult.vue?vue&type=script&lang=js"

import "./TransferResult.vue?vue&type=style&index=0&id=bfe95eba&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe95eba"]])

export default __exports__